// import { familyHistoryData } from "@constants/patientForms";
import { z } from "zod";
import { responseDetailSchema } from "../../common/schemaHelper";

/**
 * Family History validation schema
 * Validates the entire family history category
 */

export const familySchema = z.object({
  relationship: z.string().min(1, "Please select an option"),
  age: z.string(),
  deceased: z.string().min(1, "Please select an option"),
  description: z.string(),
});

export const familyHistoryValidation = z.object({
  badSleep: responseDetailSchema,
  familyMedicalConditions: z.array(familySchema),
});

export default familyHistoryValidation;
